// -- Page Templates
import frontPage from "./front-page";
import page from "./page";
import search from "./page-search";

// -- Archive Templates
import archive from "./archive/archive";
import ingredientArchive from "./archive/archive-ingredient";
import faqArchive from "./archive/archive-faqs";
import termArchive from "./archive/archive-common-terms";

// -- Single Post Templates
import single from "./single/single";
import ingredientSingle from "./single/single-ingredient";
// import singleEvent from "./single/single-event";

// The following import prevents a Font Awesome icon server-side rendering bug,
// where the icons flash from a very large icon down to a properly sized one:
import "@fortawesome/fontawesome-svg-core/styles.css";
// Prevent fontawesome from adding its CSS since we did it manually above:
import { config } from "@fortawesome/fontawesome-svg-core";
config.autoAddCss = false; /* eslint-disable import/first */

export default {
  // -- Page Templates
  "front-page": frontPage,
  // "front-page": page,
  page,
  "page-search": search,

  // -- Archive Templates
  archive,
  home: archive, // May interfere with other pages in the future? Unsure why "home" is resolved
  "archive-ingredient": ingredientArchive,
  "archive-faqs": faqArchive,
  "archive-common-terms": termArchive,

  // -- Single Post Templates
  single,
  // singular: single,
  // "single-event": singleEvent,
  "single-ingredient": ingredientSingle,
};
